<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-if="drill"
    class="select mb-3"
    :style="{ display: drill.isHidden ? 'none' : 'block' }"
    :class="{ 'is-disabled': drill.isDisabled }"
    @click="checkAlertDrill"
  >
    <select
      :id="drill.id"
      v-model="drill.selectedValue"
      :disabled="drill.isDisabled"
      :aria-label="drill.options[0].text"
      class="capitalize disabled:pointer-events-none"
      :class="selectClass"
      @change="
        $uiEvents.$emit('fitmentChanged', {
          layoutPosition: 'drilldown',
          sourceType: drill.type,
          newValue: drill.selectedValue,
        })
      "
    >
      <option
        v-for="option in drill.options"
        :key="option.text"
        :value="option.slug"
        :disabled="option.isDisabled"
        v-html="option.text"
      ></option>
    </select>
  </div>
</template>
<script setup lang="ts">
const { $uiEvents } = useNuxtApp()
const ocStore = useOrderControlStore()
const props = defineProps<{
  type: DrillKey
  groupKey?: string
}>()

const drill = ocStore.getDrill(props.type, props.groupKey)

const selectClass = computed(() => {
  return {
    '-needsSelection': drill && drill.selectedValue == '-1' && !drill.isDisabled,
  }
})

function checkAlertDrill() {
  if (drill?.isDisabled) alertDrill(props.groupKey)
}
</script>
